<template>
    <div class="status-echart">
        <div class="status-content">
            <Header :middleText="headerTitle.statusTitle" :rightIcon="headerCfg.sensorStatus.rightIcon" />
            <pieEchart :chartData="pieArray1" v-if="deviceStatus.length > 0" />
            <div v-else>
                <el-empty></el-empty>
            </div>
        </div>
        <div class="status-content">
            <Header class="header-echart" :middleText="headerTitle.typeTitle" :rightIcon="headerCfg.sensorType.rightIcon" @handleClick="handleClick('deviceType')" />
            <pieEchart :chartData="pieArray2" v-if="deviceType.length > 0" />
            <div v-else>
                <el-empty></el-empty>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../components/Header.vue';
import pieEchart from '@/components/echart/pieEchart.vue';
import { sensorStatus, sensorType } from './config/headerConfig';
export default {
    props: ['deviceStatus', 'deviceType', 'saveList', 'headerTitle'],
    watch: {
        deviceStatus(newVal) {
            this.pieArray1.pieSeries = [...newVal];
            this.pieArray1.rest.name = this.headerTitle.statusTitle;
            this.pieArray1.rest.title = this.headerTitle.statusTitle;
        },
        deviceType(newVal) {
            this.pieArray2.pieSeries = [...newVal];
            this.pieArray2.rest.name = this.headerTitle.typeTitle;
            this.pieArray2.rest.title = '';
            this.pieArray2.rest.legend = {
                 type: 'scroll',
            };
        }
    },
    components: {
        Header,
        pieEchart
    },
    data() {
        return {
            pieArray1: {
                pieSeries: [],
                rest: {
                    legend: {
                        show: false
                    },
                    isTip: true,
                    labelLine: {
                        show: true
                    },
                    label: {
                        show: true
                    }
                }
            },
            pieArray2: {
                pieSeries: [],
                rest: {
                    title: {},
                    legend: {
                        top: '2%',
                        left: 'center',
                        itemHeight: 10,
                        itemWidth: 10,
                        textStyle: {
                            //图例文字的样式
                            fontSize: 12
                        }
                    },
                    name: $t('integration.sensor_type'),
                    radius: ['30%', '50%'],
                    isTip: true,
                    labelLine: {
                        show: false
                    },
                    label: {
                        show: false,
                        position: 'center'
                    }
                }
            },
            headerCfg: {
                sensorStatus,
                sensorType
            }
        };
    },
    mounted() {},
    methods: {
        handleClick(item) {
            this.$emit('refreshFn', { item });
        }
    }
};
</script>

<style lang="scss" scoped>
.status-echart {
    border: 1px solid #ccc;
    width: 400px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .status-content {
        // flex: 1;
        height: 400px;
    }

    .header-echart {
        border-top: 1px solid #cccccc;
    }

    .echarts {
        width: 100%;
        height: 360px !important;
    }
}
</style>
